import { Component, Input, TemplateRef, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
    standalone: false
})
export class PopoverComponent implements AfterViewInit {
  @Input() title: string = '';
  @Input() template: TemplateRef<any> | null = null;
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() isOpen: boolean = false;

  @ViewChild('popoverContent') popoverContent!: ElementRef;

  ngAfterViewInit() {
    // Popover content is available here, and you can handle any additional logic needed after rendering.
  }
}
